import { Protocol } from '../../types/sharedTypeImpl.ts';
import { Change } from './change.ts';
import { getMeasurementPlanChanges } from './getMeasurementPlanChanges.ts';
import { getMetadataChanges } from './getMetadataChanges.ts';
import { getPositionChanges } from './getPositionChanges.ts';

export interface ProtocolChanges {
    metadataChanges: Change[];
    positionChanges: Change[];
    measurementPlanChanges: Change[];
}


export function getProtocolChanges(
    protocolNew: Protocol,
    protocolOld: Protocol,
    machineNames: ReadonlyMap<string, string> = new Map(),
) {
    const changes: ProtocolChanges = {
        metadataChanges: getMetadataChanges(protocolNew, protocolOld, machineNames),
        positionChanges: getPositionChanges(protocolNew, protocolOld),
        measurementPlanChanges: getMeasurementPlanChanges(protocolNew, protocolOld),
    };

    return changes;
}
